/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Master_HeadlineInputs */

const en_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master Headline`)
};

const es_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titular maestro`)
};

const fr_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre principal`)
};

const de_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptüberschrift`)
};

const ja_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マスター見出し`)
};

const zh_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主标题`)
};

const ar_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العنوان الرئيسي`)
};

const id_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headline Utama`)
};

const it_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titolo Principale`)
};

const ru_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главный заголовок`)
};

const pt_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Título Principal`)
};

const ko_master_headline = /** @type {(inputs: Master_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메인 헤드라인`)
};

/**
* | output |
* | --- |
* | "Master Headline" |
*
* @param {Master_HeadlineInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const master_headline = /** @type {((inputs?: Master_HeadlineInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Master_HeadlineInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_master_headline(inputs)
	if (locale === "es") return es_master_headline(inputs)
	if (locale === "fr") return fr_master_headline(inputs)
	if (locale === "de") return de_master_headline(inputs)
	if (locale === "ja") return ja_master_headline(inputs)
	if (locale === "zh") return zh_master_headline(inputs)
	if (locale === "ar") return ar_master_headline(inputs)
	if (locale === "id") return id_master_headline(inputs)
	if (locale === "it") return it_master_headline(inputs)
	if (locale === "ru") return ru_master_headline(inputs)
	if (locale === "pt") return pt_master_headline(inputs)
	return ko_master_headline(inputs)
});